/**
 * Product page — gallery, variant chips, accordion, price, simulator sync
 */
(function () {
  const form = document.querySelector('form[data-product-form]');
  if (!form) return;

  const ctaLabel = form.dataset.ctaLabel || 'Buy This Backdrop';

  const mainImg = document.getElementById('pdp-main-img');
  const priceEl = document.getElementById('pdp-price');
  const btnPriceEl = document.getElementById('pdp-btn-price');
  const badgeEl = document.getElementById('pdp-badge');
  const eyebrowEl = document.getElementById('pdp-eyebrow');
  const zoomHint = document.getElementById('pdp-zoomhint');
  const idInput = form.querySelector('[name="id"]');
  const addBtn = document.getElementById('pdp-add-btn');
  const stickyBar = document.getElementById('pdpStickyBar');
  const stickyBtn = document.getElementById('pdp-sticky-btn');
  const stickyPrice = document.getElementById('pdp-sticky-price');
  const buybox = document.querySelector('.pdp-buybox');
  const sizeRulerHeightEl = document.getElementById('pdp-size-ruler');
  const sizeRulerWidthEl = document.querySelector('[data-pdp-dim-width-bar]');
  const sizeCalloutDimsEl = document.querySelector('[data-pdp-size-dims]');
  const sizeMobileEl = document.getElementById('pdp-size-mobile');
  const variants = window.GravityProductVariants || [];

  const BACKDROP_SIZES = {
    XS: { w: '1.2', h: '2.4', metric: '1.2 × 2.4m', imperial: '3.9 × 7.9 ft' },
    Standard: { w: '1.6', h: '2.7', metric: '1.6 × 2.7m', imperial: '5.2 × 8.9 ft' },
    Mid: { w: '1.9', h: '2.7', metric: '1.9 × 2.7m', imperial: '6.2 × 8.9 ft' },
    Large: { w: '2.1', h: '2.7', metric: '2.1 × 2.7m', imperial: '6.9 × 8.9 ft' },
    'Large+': { w: '2.7', h: '3', metric: '2.7 × 3m', imperial: '8.9 × 9.8 ft' },
    XL: { w: '2.7', h: '4', metric: '2.7 × 4m', imperial: '8.9 × 13.1 ft' },
    XXL: { w: '2.7', h: '5', metric: '2.7 × 5m', imperial: '8.9 × 16.4 ft' },
    XXXL: { w: '2.7', h: '6', metric: '2.7 × 6m', imperial: '8.9 × 19.7 ft' },
  };
  const productImages = window.GravityProductImages || [];
  const moneyFormat = window.GravityMoneyFormat || '€{{amount}}';
  const optionInputs = () =>
    [...form.querySelectorAll('[data-pdp-option-input]')].sort(
      (a, b) =>
        parseInt(a.dataset.optionIndex, 10) - parseInt(b.dataset.optionIndex, 10)
    );

  let addBtnDefaultHtml = addBtn ? addBtn.innerHTML : '';
  let inCartSyncSeq = 0;
  const optionsRoot = form.querySelector('[data-pdp-options]');
  const optionsToggle = form.querySelector('[data-pdp-options-toggle]');
  const optionsToggleLabel = form.querySelector('[data-pdp-options-toggle-label]');

  function formatOptionDisplay(value) {
    return value.replace(/ Text$/i, '').replace(/ texture$/i, '');
  }

  function setOptionsPanelOpen(open, focusOptionIndex) {
    if (!optionsRoot || !optionsToggle) return;
    optionsRoot.classList.toggle('is-open', open);
    optionsToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (optionsToggleLabel) {
      optionsToggleLabel.textContent = open ? 'Done' : 'Customize';
    }
    form.querySelectorAll('[data-pdp-option-group]').forEach((group) => {
      group.classList.remove('is-focused');
    });
    if (open && focusOptionIndex != null) {
      const group = form.querySelector(
        `[data-pdp-option-group][data-option-index="${focusOptionIndex}"]`
      );
      group?.classList.add('is-focused');
      group?.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  }

  function syncOptionsSummary() {
    const selected = selectedOptionValues();
    form.querySelectorAll('[data-pdp-summary-pill]').forEach((pill) => {
      const idx = parseInt(pill.dataset.optionIndex, 10);
      const value = selected[idx];
      if (value == null) return;

      const valEl = pill.querySelector('[data-pdp-summary-value]');
      if (valEl) valEl.textContent = formatOptionDisplay(value);

      const chip = form.querySelector(
        `[data-pdp-chip][data-option-index="${idx}"][aria-pressed="true"]`
      );
      const pillSwatch = pill.querySelector('.pdp-options__pill-swatch');
      const chipSwatch = chip?.querySelector('.pdp-chip__swatch');
      if (pillSwatch && chipSwatch?.style.background) {
        pillSwatch.style.background = chipSwatch.style.background;
      }
    });
  }

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    if (moneyFormat.includes('{{amount_with_comma_separator}}')) {
      return moneyFormat.replace(
        '{{amount_with_comma_separator}}',
        amount.replace('.', ',')
      );
    }
    if (moneyFormat.includes('{{amount_no_decimals}}')) {
      return moneyFormat.replace(
        '{{amount_no_decimals}}',
        String(Math.round(cents / 100))
      );
    }
    return moneyFormat.replace('{{amount}}', amount);
  }

  function syncSimulatorImage(src, alt) {
    if (!src) return;
    const hiRes = /([?&])width=\d+/.test(src)
      ? src.replace(/([?&])width=\d+/, '$1width=2400')
      : src + (src.includes('?') ? '&' : '?') + 'width=2400';
    document.dispatchEvent(
      new CustomEvent('gravity:product-image', {
        detail: { src: hiRes, alt: alt || '' },
      })
    );
  }

  function imagePath(url) {
    if (!url) return '';
    try {
      return new URL(url, window.location.origin).pathname;
    } catch {
      return String(url).split('?')[0];
    }
  }

  function variantImageSrc(variant) {
    if (!variant) return null;
    if (variant.featured_image && variant.featured_image.src) {
      return variant.featured_image.src;
    }
    if (variant.image_id && productImages.length) {
      const match = productImages.find((img) => img.id === variant.image_id);
      if (match && match.src) return match.src;
    }
    return null;
  }

  function setActiveThumb(src, imageId) {
    if (!thumbs) return null;
    const path = imagePath(src);
    let active = null;
    thumbs.querySelectorAll('button[data-src]').forEach((btn) => {
      const matches =
        (imageId && btn.dataset.imageId === String(imageId)) ||
        (path && imagePath(btn.dataset.src) === path);
      btn.classList.toggle('active', matches);
      if (matches) active = btn;
    });
    return active;
  }

  function setMainImage(src, alt, objectPosition) {
    if (!mainImg || !src) return;

    const nextPath = imagePath(src);
    const currentPath = imagePath(mainImg.currentSrc || mainImg.src);
    if (nextPath && currentPath && nextPath === currentPath) {
      mainImg.style.opacity = '1';
      if (alt) mainImg.alt = alt;
      if (objectPosition) mainImg.style.objectPosition = objectPosition;
      return;
    }

    const reveal = () => {
      mainImg.src = src;
      mainImg.removeAttribute('srcset');
      mainImg.removeAttribute('sizes');
      if (alt) mainImg.alt = alt;
      if (objectPosition) mainImg.style.objectPosition = objectPosition;
      mainImg.style.opacity = '1';
    };

    mainImg.style.opacity = '0';
    const preload = new Image();
    preload.onload = reveal;
    preload.onerror = () => {
      mainImg.style.opacity = '1';
    };
    preload.src = src;
    if (preload.complete) reveal();
  }

  function showProductImage(src, alt, objectPosition, imageId) {
    if (!src) return;
    const thumb = setActiveThumb(src, imageId);
    const pos = objectPosition || thumb?.dataset.position || 'center';
    setMainImage(src, alt || mainImg?.alt || '', pos);
    syncSimulatorImage(src, alt || mainImg?.alt || '');
    if (zoomHint && thumb) {
      const idx = thumb.dataset.index || '1';
      const total = thumbs.querySelectorAll('button[data-src]').length;
      zoomHint.textContent = idx + ' of ' + total + ' · painted original';
    }
  }

  function selectedOptionValues() {
    return optionInputs().map((input) => input.value);
  }

  function getSelectedVariant() {
    if (!variants.length) return null;
    const options = selectedOptionValues();
    return variants.find((v) =>
      v.options.every((opt, i) => opt === options[i])
    );
  }

  function isOptionValueAvailable(optionIndex, value) {
    const current = selectedOptionValues();
    return variants.some((v) => {
      if (!v.available) return false;
      return v.options.every((opt, i) => {
        if (i === optionIndex) return opt === value;
        return !current[i] || current[i] === opt;
      });
    });
  }

  function syncChipPressedState() {
    const selected = selectedOptionValues();
    form.querySelectorAll('[data-pdp-chip]').forEach((chip) => {
      const idx = parseInt(chip.dataset.optionIndex, 10);
      const pressed = chip.dataset.value === selected[idx];
      chip.setAttribute('aria-pressed', pressed ? 'true' : 'false');
    });
  }

  function syncChipAvailability() {
    form.querySelectorAll('[data-pdp-chip]').forEach((chip) => {
      const idx = parseInt(chip.dataset.optionIndex, 10);
      const available = isOptionValueAvailable(idx, chip.dataset.value);
      const pressed = chip.getAttribute('aria-pressed') === 'true';
      if (pressed) {
        chip.disabled = false;
        chip.setAttribute('aria-disabled', 'false');
        return;
      }
      chip.disabled = !available;
      chip.setAttribute('aria-disabled', available ? 'false' : 'true');
    });
  }

  function parseImperialAxis(imperial, axis) {
    const parts = imperial.replace(/\s*ft\s*$/, '').split(' × ');
    return axis === 'w' ? parts[0] : parts[1];
  }

  function formatDimAxisDisplay(spec, axis) {
    if (!spec) return '';
    const m = axis === 'w' ? spec.w : spec.h;
    const ft = parseImperialAxis(spec.imperial, axis);
    const units =
      '<span class="pdp-dims-metric">' +
      m +
      'm</span>' +
      '<span class="pdp-dims-imperial">' +
      ft +
      ' ft</span>';
    if (axis === 'h') {
      return '<span class="pdp-dim__label-inner">' + units + '</span>';
    }
    return units;
  }

  function formatDimsDisplay(spec) {
    if (!spec) return '';
    return (
      '<span class="pdp-dims-metric">' +
      spec.metric +
      '</span> <span class="pdp-dims-imperial">' +
      spec.imperial +
      '</span>'
    );
  }

  function updateSizeChartHighlight(sizeKey) {
    document.querySelectorAll('.backdrop-size-chart__cell').forEach((cell) => {
      cell.classList.toggle('is-current', cell.dataset.sizeKey === sizeKey);
    });
  }

  function updateSizeRuler(sizeKey) {
    if (!sizeRulerHeightEl && !sizeRulerWidthEl) return;
    const spec = BACKDROP_SIZES[sizeKey];
    if (!spec) {
      if (sizeRulerHeightEl) sizeRulerHeightEl.hidden = true;
      if (sizeRulerWidthEl) sizeRulerWidthEl.hidden = true;
      if (sizeCalloutDimsEl) sizeCalloutDimsEl.innerHTML = '';
      if (sizeMobileEl) sizeMobileEl.innerHTML = '';
      return;
    }
    if (sizeRulerHeightEl) {
      sizeRulerHeightEl.hidden = false;
      sizeRulerHeightEl.dataset.size = sizeKey;
    }
    if (sizeRulerWidthEl) sizeRulerWidthEl.hidden = false;

    const widthEl = document.querySelector('[data-pdp-dim-width]');
    const heightEl = document.querySelector('[data-pdp-dim-height]');
    if (widthEl) widthEl.innerHTML = formatDimAxisDisplay(spec, 'w');
    if (heightEl) heightEl.innerHTML = formatDimAxisDisplay(spec, 'h');

    const dimsHtml = formatDimsDisplay(spec);
    if (sizeCalloutDimsEl) sizeCalloutDimsEl.innerHTML = dimsHtml;
    if (sizeMobileEl) sizeMobileEl.innerHTML = dimsHtml;
    updateSizeChartHighlight(sizeKey);
  }

  function updateVariantUI() {
    syncChipAvailability();
    syncChipPressedState();

    const match = getSelectedVariant();
    if (!match) return;
    if (idInput) idInput.value = match.id;

    const line = formatMoney(match.price);
    if (priceEl) priceEl.textContent = line;

    if (addBtn) {
      if (!match.available) {
        addBtn.disabled = true;
        addBtn.classList.remove('is-in-cart');
        addBtn.textContent = 'Sold out — this piece has shipped';
      }
    }

    if (badgeEl && match.option1) badgeEl.textContent = match.option1;
    if (eyebrowEl && match.option1) {
      const tex = match.option2
        ? ' · ' + match.option2.replace(/ Text$/i, '')
        : '';
      eyebrowEl.textContent =
        match.option1 + ' size' + tex + ' · Hand-painted original';
    }

    if (match.option1) updateSizeRuler(match.option1);

    syncOptionsSummary();

    const variantSrc = variantImageSrc(match);
    if (variantSrc) {
      showProductImage(variantSrc, mainImg?.alt || '', null, match.image_id);
    }

    syncCartButtonState(match);
  }

  async function syncCartButtonState(match) {
    const variant = match || getSelectedVariant();
    if (!variant || !addBtn) return;

    if (!variant.available) {
      syncStickyBar(variant, false, true);
      return;
    }

    const seq = ++inCartSyncSeq;
    let inCart = false;
    if (window.GravityCart && window.GravityCart.isVariantInCart) {
      try {
        inCart = await window.GravityCart.isVariantInCart(variant.id);
      } catch (err) {
        inCart = false;
      }
    }
    if (seq !== inCartSyncSeq) return;

    if (inCart) {
      addBtn.disabled = true;
      addBtn.classList.add('is-in-cart');
      addBtn.textContent = 'Already in your bag';
    } else {
      addBtn.disabled = false;
      addBtn.classList.remove('is-in-cart');
      addBtn.replaceChildren();
      const labelEl = document.createElement('span');
      labelEl.className = 'add-btn__label';
      labelEl.textContent = ctaLabel;
      const priceEl = document.createElement('span');
      priceEl.className = 'add-btn__price';
      priceEl.id = 'pdp-btn-price';
      priceEl.textContent = formatMoney(variant.price);
      addBtn.appendChild(labelEl);
      addBtn.appendChild(priceEl);
      addBtnDefaultHtml = addBtn.innerHTML;
    }

    syncStickyBar(variant, inCart, false);
  }

  function syncStickyBar(variant, inCart, soldOut) {
    const match = variant || getSelectedVariant();
    if (!match) return;
    const isSoldOut = soldOut != null ? soldOut : !match.available;
    const isInCart =
      inCart != null ? inCart : !!addBtn?.classList.contains('is-in-cart');
    if (stickyPrice && match) {
      stickyPrice.textContent = formatMoney(match.price);
    }
    if (stickyBtn && addBtn) {
      if (isSoldOut) {
        stickyBtn.disabled = true;
        stickyBtn.textContent = 'Sold out';
      } else if (isInCart) {
        stickyBtn.disabled = true;
        stickyBtn.textContent = 'Already in your bag';
      } else {
        stickyBtn.disabled = addBtn.disabled;
        stickyBtn.textContent = ctaLabel;
      }
    }
    if (stickyBar && buybox && addBtn) {
      const pastBuybox = buybox.getBoundingClientRect().bottom < 0;
      const showBar = pastBuybox && !isSoldOut && !isInCart;
      stickyBar.classList.toggle('is-visible', showBar);
      stickyBar.setAttribute('aria-hidden', showBar ? 'false' : 'true');
    }
  }

  function selectOption(optionIndex, value) {
    const input = optionInputs().find(
      (el) => parseInt(el.dataset.optionIndex, 10) === optionIndex
    );
    if (!input || input.value === value) return;
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    updateVariantUI();
  }

  form.querySelectorAll('[data-pdp-chip]').forEach((chip) => {
    chip.addEventListener('click', () => {
      if (chip.disabled || chip.getAttribute('aria-disabled') === 'true') return;
      const optionIndex = parseInt(chip.dataset.optionIndex, 10);
      selectOption(optionIndex, chip.dataset.value);
    });
  });

  optionsToggle?.addEventListener('click', () => {
    setOptionsPanelOpen(!optionsRoot.classList.contains('is-open'));
  });

  form.querySelectorAll('[data-pdp-summary-pill]:not([disabled])').forEach((pill) => {
    pill.addEventListener('click', () => {
      setOptionsPanelOpen(true, parseInt(pill.dataset.optionIndex, 10));
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && optionsRoot?.classList.contains('is-open')) {
      setOptionsPanelOpen(false);
    }
  });

  form.addEventListener('change', updateVariantUI);

  const thumbs = document.getElementById('pdp-thumbs');
  if (thumbs && mainImg) {
    thumbs.querySelectorAll('button[data-src]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const src = btn.dataset.src;
        const pos = btn.dataset.position || 'center';
        const imageId = btn.dataset.imageId
          ? parseInt(btn.dataset.imageId, 10)
          : null;
        showProductImage(src, mainImg.alt, pos, imageId);
      });
    });
  }

  document.querySelectorAll('.acc-head').forEach((head) => {
    head.addEventListener('click', () => {
      const item = head.parentElement;
      const body = head.nextElementSibling;
      const open = item.classList.toggle('open');
      body.style.maxHeight = open ? body.scrollHeight + 'px' : '0';
    });
  });

  if (addBtn) {
    addBtnDefaultHtml = addBtn.innerHTML;
    document.addEventListener('gravity:cart-added', () => {
      addBtn.classList.add('added');
      addBtn.textContent = '✓ Added to bag';
      setTimeout(() => {
        addBtn.classList.remove('added');
        syncCartButtonState();
      }, 1900);
    });
    document.addEventListener('gravity:cart-updated', () => {
      syncCartButtonState();
    });
    document.addEventListener('gravity:cart-duplicate', () => {
      syncCartButtonState();
    });
  }

  if (mainImg?.src) {
    const initialSrc = mainImg.currentSrc || mainImg.src;
    syncSimulatorImage(initialSrc, mainImg.alt);
  }

  if (stickyBar && buybox && addBtn && stickyBtn) {
    stickyBar.hidden = false;

    stickyBtn.addEventListener('click', () => {
      if (addBtn.disabled) return;
      addBtn.click();
    });

    window.addEventListener('scroll', () => syncStickyBar(), { passive: true });
  }

  updateVariantUI();
})();
